var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef, memo } from "react";
const SvgUser28 = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_533_93)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 38,
    height: 38,
    fill: "#034336"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.6538 5.92809C16.2258 5.5957 18.4019 7.78685 18.3981 10.87L18.3981 10.8703C18.3915 10.9181 18.3852 10.9794 18.3778 11.0504C18.356 11.2621 18.3251 11.5604 18.2525 11.8482C17.8307 13.4943 16.9237 14.7522 15.2402 15.2561C13.7509 15.704 12.4407 15.2747 11.3508 14.1848C9.9137 12.744 9.53298 10.3438 10.4475 8.42895C11.097 7.07029 12.1122 6.12592 13.6538 5.92809ZM15.6331 22.102C15.1673 22.1018 14.7017 22.1016 14.2363 22.1016L14.2365 22.1016C12.3253 22.1053 10.4105 22.109 8.49938 22.0978C7.43182 22.0904 6.73009 21.6275 6.39415 20.7466C6.00224 19.7164 6.42402 18.6265 7.54754 17.977C8.79413 17.2566 10.067 16.5847 11.351 15.9315C11.5675 15.8233 11.9258 15.8382 12.161 15.939C13.5196 16.5213 14.8558 16.5176 16.207 15.924C16.3937 15.8382 16.6736 15.7561 16.8229 15.8345C17.0512 15.9564 17.2799 16.0779 17.5085 16.1993C18.7491 16.8583 19.9901 17.5174 21.1751 18.2644C22.0486 18.8169 22.2838 19.8172 21.9777 20.7018C21.6679 21.5977 20.9213 22.0941 19.8277 22.0978C18.4307 22.1034 17.0313 22.1027 15.6331 22.102Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_533_93"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "white"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgUser28);
const Memo = /*#__PURE__*/memo(ForwardRef);
export default Memo;